import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const saveModuleApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}module`,
        method: params.mode === "edit" ? "put" : "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })

    return response

}

export default saveModuleApi